import moment from 'moment';

export const SCROLL_BAR_CANDIDATE = [
  { title: 'Parsing', id: 'parsing' },
  { title: 'Profile', id: 'profile' },
  { title: 'Contact information', id: 'contact_information' },
  { title: 'Experience', id: 'experience' },
  { title: 'Working experience', id: 'working_experience' },
];

export const EMPTY_CANDIDATE_DATA = {
  '': undefined,
  first_name_latin: '',
  last_name_latin: '',
  first_name_local: '',
  last_name_local: '',
  country: undefined,
  city: [] as unknown[],
  cv_link_0: '',
  cv_link_1: '',
  cvs: undefined as unknown,
  offices: [] as unknown[],
  sources: [{ source: undefined, is_main: true }],
  timezone: undefined,
  description: '',
  description_initial: '',
  foreign_languages: [{ language: undefined, level: undefined }],
  is_ready_to_relocate: false,
  is_ready_to_business_trips: false,
  phone: [''],
  email: [''],
  telegram: '',
  social_networks: [{ link: '', network: undefined as unknown }],
  specialities: [{ language: undefined, level: { value: 'No Level', label: 'No Level' } }],
  tags: [] as unknown[],
  experience: [
    {
      company: undefined as unknown,
      position: undefined as unknown,
      is_current: false,
      worked_from: moment(),
      worked_till: moment(),
      additional_info: '',
    },
  ],
};
